// ═══════════════════════════════════════════════════════════════
// notificationsApi.js — Service API notifications ITRIIA
// ═══════════════════════════════════════════════════════════════

const getToken = () => localStorage.getItem('oracle_token');

const headers = () => ({
    'Authorization': `Bearer ${getToken()}`,
    'Content-Type': 'application/json',
});

export async function fetchNotifications({ unreadOnly = false, limit = 50 } = {}) {
    const params = new URLSearchParams();
    if (unreadOnly) params.set('unread_only', 'true');
    if (limit) params.set('limit', String(limit));
    const response = await fetch(`/api/notifications?${params}`, { headers: headers() });
    if (!response.ok) throw new Error(`Erreur ${response.status}`);
    return response.json();
}

export async function fetchUnreadCount() {
    const response = await fetch('/api/notifications/unread-count', { headers: headers() });
    if (!response.ok) throw new Error(`Erreur ${response.status}`);
    const data = await response.json();
    return data.count;
}

export async function markAsRead(notificationId) {
    const response = await fetch(`/api/notifications/${notificationId}/read`, {
        method: 'PATCH',
        headers: headers(),
    });
    if (!response.ok) throw new Error(`Erreur ${response.status}`);
    return response.json();
}

export async function markAllAsRead() {
    const response = await fetch('/api/notifications/mark-all-read', {
        method: 'POST',
        headers: headers(),
    });
    if (!response.ok) throw new Error(`Erreur ${response.status}`);
    return response.json();
}
